module.exports = __webpack_public_path__ + "img/PPT版_00.eeabc493.png";